"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { Frame } from "@/components/ui/frame";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  count?: string;
  imageMetadata?: ImageMetadata;
};

export const VerticalSmallImagesNewsWhite = ({
  title = { hidden: false, value: "பெண் பார்க்க போன வெற்றிக்கு ஷக்தி வைத்த ட்விஸ்ட்.!", customClass: "" },
  timeAgo = { hidden: false, value: "2 hours ago", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  count = "5",
  imageMetadata,
}: Props) => {
  const titleValue = title?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <div className="flex flex-col overflow-hidden p-4 gap-4 ">
      {/* IMAGE */}
      {!imageSrc?.hidden && (
        <div>
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <Image
              src={imageSrcValue}
              alt={titleValue}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 280px"
              className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`}
              style={getFocusPointStyle(imageMetadata)}
              loading="lazy"
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
            {/* <div className="absolute top-2 right-2">
              <Frame id={count} />
            </div> */}
          </div>
        </div>
      )}

      {/* CONTENT */}
      <div className="flex flex-col gap-5">
        {/* Title */}
        {!title?.hidden && (
 <h3 className={`text-14-tamil-700 leading-[1.4] text-FFFFFF ${title?.customClass || ""}`}>
            {titleValue}
          </h3>
        )}

        {/* Footer */}
        <div className="flex justify-between items-center text-FFFFFF gap-3">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-FFFFFF ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}
          <MessageIcon
            id="small-image-news-vert-message-icon"
            variant="message-icon-4"
            slug={slug}
            category={BOOKMARK_CATEGORIES.PHOTOS}
            title={titleValue}
            thumbnailUrl={imageSrcValue}
            articleUrl={slug ? `/${slug}` : undefined}
          />
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block transition-opacity cursor-pointer text-FFFFFF">
        {content}
      </Link>
    );
  }

  return content;
};
